import { Anchor, Box, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { WebSocketStatus } from '../ui';
import { env } from '../../config/env';
import { useUserStore } from '../../context';

export const FooterNav = observer(() => {
  const userStore = useUserStore();
  const year = new Date().getFullYear();

  return (
    <Box
      direction="row"
      justify="center"
      align="center"
      fill="horizontal"
      background="background-back"
      pad={{ vertical: '2px', horizontal: 'medium' }}
    >
      <Box width="10%" />
      <Box width="80%" direction="row" justify="center" gap="xsmall">
        <Text size="xsmall" color="text-meta">
          Copyright &copy; {year}
        </Text>
        <Anchor href="https://www.aktarytech.com" target="_blank" color="text-meta" weight="normal">
          <Text size="xsmall">AktaryTech</Text>
        </Anchor>
      </Box>
      <Box width="10%" align="end">
        {env.nodeEnv === 'development' && userStore.user?.id && <WebSocketStatus />}
      </Box>
    </Box>
  );
});
